import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import ReactPlayer from "react-player/lazy"

import { useIntersection } from "helpers/use-intersection"

/**
 * Product video component
 * @param {string} index - video index
 * @param {string} currentSlideIndex - current slide index
 * @param {string} video - video url
 */
const ProductVideo = ({ index, currentSlideIndex, video }) => {
  const ref = useRef()
  const inViewport = useIntersection(ref, "0px")

  return (
    <Box
      maxHeight={{
        _: "100%",
        desktop: "500px",
        tablet: "325px",
      }}
      maxWidth={{
        _: "100%",
        desktop: "500px",
        tablet: "325px",
      }}
      mx="auto"
      ref={ref}
    >
      {inViewport && (
        <ReactPlayer
          config={{
            file: {
              attributes: {
                preload: "metadata",
              },
            },
            vimeo: {
              url: { video },
            },
          }}
          controls={currentSlideIndex === index}
          height="100%"
          loop
          muted
          playing={currentSlideIndex === index}
          playsinline
          url={video}
          width="100%"
        />
      )}
    </Box>
  )
}

ProductVideo.propTypes = {
  currentSlideIndex: PropTypes.number,
  index: PropTypes.number,
  video: PropTypes.string,
}

export default ProductVideo
